import React from 'react';
import { PageContext } from '../contexts/page-context';
import { i18nInitNamespace } from './i18n';

export const useI18nInitNamespace = (name, translations, setDefault) => {
  const { pageProps } = React.useContext(PageContext);
  i18nInitNamespace(name, translations, setDefault, pageProps);
};
